export const hrHR = {
  app: {
    categories: {
      convectors: 'Konvektori',
      decorative: 'Dekorativni',
      electric: 'Električni',
      panels: 'Paneli',
      towel: 'Grijači ručnika',
    },
    categoryLabel: 'Kategorija',
    categoryPlaceholder: 'Odaberite kategoriju',
    errorCategories: 'Učitavanje kategorija nije uspjelo.',
    errorPanels: 'Učitavanje radijatora nije uspjelo.',
    loadingCategories: 'Učitavanje kategorija...',
    loadingPanels: 'Učitavanje radijatora...',
    panelLabel: 'Radijatori',
    panelPlaceholder: 'Odaberite radijator',
    titles: {
      convectors: 'Kalkulator konvektora',
      decorative: 'Kalkulator dizajnerskih radijatora',
      electric: 'Kalkulator električnih radijatora',
      panels: 'Kalkulator panelnih radijatora',
      towel: 'Kalkulator grijača ručnika',
    },
  },
  calc: {
    actionButton: 'Prikaži izračunate stavke',
    boost: 'Boost način rada',
    calculateRequiredButton: 'Izračunaj potrebne watte',
    calculating: 'Izračunavanje...',
    comfort: 'Udobni način rada',
    downloadLabel: 'Preuzmi podatke ({count})',
    emptyResults: 'Još nema rezultata.',
    errorMatch: 'Izračunavanje rezultata nije uspjelo.',
    errorTypes: 'Učitavanje vrsta radijatora nije uspjelo.',
    flowTemp: 'Temperatura polaza C°',
    height: 'Visina',
    length: 'Duljina',
    loadingTypes: 'Učitavanje vrsta...',
    modeLabel: 'Način rada',
    modes: {
      cooling: 'Hlađenje',
      heating: 'Grijanje',
    },
    radiatorType: 'Vrsta radijatora',
    requiredWatts: 'Potrebni watti',
    resultsMessage: '{count} stavki dostupno za odabrane opcije.',
    returnTemp: 'Temperatura povrata C°',
    roomTemp: 'Temperatura prostorije C°',
    selectAllLabel: 'Odaberi sve stavke',
    selectItemLabel: 'Odaberite stavku za preuzimanje',
    selectPanel: 'Odaberite panel za izračun.',
    standby: 'Način mirovanja',
    tableHeaders: {
      calculatedWattage: 'Watti',
      co2Equivalent: 'CO2 ekvivalent po kg materijala',
      depth: 'Dubina [mm]',
      description: 'Opis stavke',
      dop: 'DOP',
      eudop: 'EU DOP',
      height: 'Visina [mm]',
      itemId: 'Šifra stavke',
      length: 'Duljina [mm]',
      waterContent: 'Sadržaj vode',
      weight: 'Težina',
    },
    title: 'Izračuni',
    tolerance: 'Tolerancija',
    typeCooling: 'Hlađenje',
    typeGroupLabel: 'Vrsta',
    typeHeating: 'Grijanje',
  },
  existingRadiator: {
    description:
      'Ovaj kalkulator je samo informativne prirode. Uvijek se posavjetujte s profesionalnim instalaterom za točan izračun prije kupnje radijatora.',
    height: 'Visina radijatora',
    length: 'Duljina radijatora',
    resultLabelTemplate: 'Zahtjev za toplinskim učinkom, izračunat pri temperaturi sustava {temp}',
    select: 'Odaberi',
    temperature: 'Temperatura sustava',
    type: 'Vrsta radijatora',
  },
  matrixCalc: {
    axisHeight: 'Visina (mm)',
    axisLength: 'Duljina (mm)',
    axisType: 'Tip',
    calculateButton: 'Calculate',
    displayLabel: 'Prikaz',
    exportExcel: 'Izvezi u Excel',
    exportPdf: 'Izvezi u PDF',
    print: 'Ispis',
    hideOutOfRange: 'Sakrij artikle izvan raspona',
    showAll: 'Prikaži sve',
    loading: 'Loading...',
    lockHeight: 'Visina',
    lockLabel: 'Zaključaj dimenziju',
    lockLength: 'Duljina',
    lockType: 'Tip',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Izračunaj',
    clearButton: 'Očisti sve',
    fields: {
      ceilingHeight: 'Visina stropa',
      doorInsulation: 'Izolacija vrata',
      floorInsulation: 'Izolacija poda',
      glazingArea: 'Površina ostakljenja',
      glazingMode: 'Površina ostakljenja',
      glazingQuality: 'Kvaliteta ostakljenja',
      length: 'Duljina',
      outerWalls: 'Vanjski zidovi',
      projectedDesignTemp: 'Projektna vanjska temperatura (PVT) za lokaciju zgrade',
      roofInsulation: 'Izolacija krova',
      roomArea: 'Površina prostorije',
      roomFloor: 'Kat',
      roomInsulation: 'Izolacija prostorije',
      roomPreset: 'Vrsta prostorije',
      roomTemperature: 'Temperatura prostorije',
      roomType: 'Vrsta prostorije',
      uncertaintyFactor: 'Faktor nesigurnosti',
      ventilation: 'Razina ventilacije',
      wallInsulation: 'Izolacija zidova',
      width: 'Širina',
      windConditions: 'Uvjeti vjetra',
      windowInsulation: 'Izolacija prozora',
    },
    intro:
      'Izračunajte toplinske gubitke u prostoriji kako biste odabrali pravi proizvod iz naše ponude radijatora.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Više od 20%',
        low: 'Manje od 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Iznad 20%',
        below_10: 'Ispod 10%',
        from_10_to_20: 'Od 10% do 20%',
        no_windows: 'Bez prozora',
      },
      insulationValue: {
        good: 'Dobra',
        medium: 'Srednja',
        poor: 'Loša',
        very_good: 'Vrlo dobra',
      },
      qualityValue: {
        modern_excellent: 'Moderna, izvrsna energetska učinkovitost',
        modern_good: 'Moderna, dobra energetska učinkovitost',
        old_poor: 'Stara, vrlo loša energetska učinkovitost',
        traditional_medium: 'Tradicionalna, srednja energetska učinkovitost',
      },
      roomValue: {
        bathroom_24: 'Kupaonica (24 C°)',
        bedroom_20: 'Spavaća soba (20 C°)',
        garage_12: 'Garaža (12 C°)',
        livingroom_22: 'Dnevna soba (22 C°)',
        storage_16: 'Ostava (16 C°)',
      },
      select: 'Odaberi',
      storeyValue: {
        ground_multi: 'Prizemlje (višekatnica)',
        ground_single: 'Prizemlje (jednokatnica)',
        interim: 'Srednji kat',
        top_multi: 'Najviši kat (višekatnica)',
      },
      temp: {
        climate_zone_1: 'PVT -12 C°',
        climate_zone_2: 'PVT -14 C°',
        climate_zone_3: 'PVT -16 C°',
        climate_zone_4: 'PVT -18 C°',
        climate_zone_5: 'PVT -20 C°',
        climate_zone_6: 'PVT -22 C°',
        climate_zone_7: 'PVT -24 C°',
        climate_zone_8: 'PVT -26 C°',
      },
      windInfluence: {
        normal: 'Normalni',
        strong: 'Jaki',
        weak: 'Slabi',
      },
    },
    roomPresets: {
      bathroom: 'Kupaonica',
      bedroom: 'Spavaća soba',
      garage: 'Garaža',
      kitchen: 'Kuhinja',
      living: 'Dnevna soba',
      storage: 'Ostava',
    },
    sections: {
      dimensions: 'Dimenzije prostorije',
      insulation: 'Izolacija',
      placement: 'Smještaj',
      result: 'Rezultat',
      temps: 'Temperature',
      ventilation: 'Ventilacija',
    },
    title: 'Kalkulator toplinskih gubitaka',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Koristi',
  },
  slider: {
    from: 'Od',
    to: 'Do',
    value: 'Vrijednost',
  },
}
